import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {Paper, TextField, Typography, Input, FormControl, InputAdornment, Menu, Button} from "@material-ui/core";
import {AccountCircle, Search, ArrowBack, Add} from '@material-ui/icons';
import Filter_1 from "../../icons/PNGs/filtro_1.png";
import Filter_2 from "../../icons/PNGs/filtro_2.png";
import {partnerService} from "../../services/PartnerService";
import {IPartnersSections} from "../../types";
import FiltersMenu from "./FiltersMenu";
import {callback} from "chart.js/helpers";


interface IProps {
    section: IPartnersSections
    filtroTexto: string
    cropsense: boolean
    setFiltroTexto(text: string): void
    setCropsense(cropsense: boolean): void
    setCrearPromocion(callback: boolean): void
}

interface Istate {
    openFilters: boolean
    anchorEl: Element | null
}


class NavBarHorizontal extends React.Component<IProps, Istate> {

    state:Istate = {
        openFilters: false,
        anchorEl: null
    }


    render() {
        return (
            <Paper
                elevation={2}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: "center",
                    width: '100%',
                    height: 70,
                    marginLeft: -1,
                    backgroundColor: "white",
                    borderRadius: 0
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: "center",
                        justifyContent: "center",
                        width: 'calc(100% - 300px)',
                        height: '100%'
                    }}
                >
                    {this.props.section === "clientes" && !this.props.cropsense &&
                        <FormControl >
                            <Input
                                style={{
                                    width: 280,
                                    height: 40,
                                    backgroundColor: "#ECECEC",
                                    borderRadius: 20
                                }}
                                disableUnderline
                                inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                placeholder={"buscar..."}
                                value={this.props.filtroTexto}
                                onChange={e => {
                                    this.props.setFiltroTexto(e.target.value)
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Search
                                            style={{
                                                color: "#666",
                                                marginLeft: 10
                                            }}
                                        />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    }
                    {this.props.section === "clientes" && !this.props.cropsense &&
                        <div
                            style={{
                                marginLeft: 20
                            }}
                        >
                            <img
                                style={{
                                    height: 20,
                                    width: 20,
                                    cursor: "pointer",
                                    color: "#666"
                                }}
                                src={Filter_1}
                                alt="img"
                                onClick={(e) => {
                                    this.setState({openFilters: !this.state.openFilters, anchorEl: e.currentTarget})
                                }}
                            />
                            <Menu
                                open={this.state.openFilters}
                                onClose={() => {
                                    this.setState({openFilters: false, anchorEl: null})
                                }}
                                anchorEl={this.state.anchorEl}
                            >
                                <div
                                    style={{
                                        width: 400,
                                        height: "80vH"
                                    }}
                                >
                                    <FiltersMenu />
                                </div>
                            </Menu>
                        </div>

                    }

                    {this.props.section === "clientes" && this.props.cropsense &&
                        <Button
                            style={{
                                textTransform: "none"
                            }}
                            variant={"outlined"}
                            onClick={() => {
                                this.props.setCropsense(false)
                            }}
                        >
                            <ArrowBack/>

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    marginRight: 5,
                                    fontSize: 18,
                                    fontWeight: "bold"
                                }}
                            >
                                Volver
                            </Typography>

                        </Button>
                    }

                    {this.props.section === "promociones" &&
                        <Button
                            style={{
                                textTransform: "none"
                            }}
                            variant={"outlined"}
                            onClick={() => {
                                this.props.setCrearPromocion(true)
                            }}
                        >
                            <Add/>

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    marginRight: 5,
                                    fontSize: 18,
                                    fontWeight: "bold"
                                }}
                            >
                                Crear Promoción
                            </Typography>

                        </Button>
                    }

                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: 50,
                        height: '100%',
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div style={{width: 2, height: "80%", backgroundColor: "#ECECEC"}}/>
                </div>



                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        width: 250,
                        height: '100%'
                    }}
                >
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            fontSize: 18
                        }}
                    >
                        {partnerService.getUser()}
                    </Typography>

                    <div
                        style={{
                            width: 50,
                            height: 50,
                            borderRadius: 25
                        }}
                    >
                        <AccountCircle
                            style={{
                                height: 50,
                                width: 50
                            }}
                        />
                    </div>

                </div>

            </Paper>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    section: state.navegacionPartners.section,
    filtroTexto: state.partner.filtroTexto
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setFiltroTexto: (text: string) => dispatch({type: "set-filtro-texto", text}),
    setCropsense: (cropsense: boolean) => dispatch({type: "set-cropsense", cropsense}),
    setCrearPromocion: (callback: boolean) => dispatch({type: "open-new-promocion-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBarHorizontal);
